<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue
      code="etes-vous-membre-autre-ordre"
      v-model="sas.sasInscriptionAuTableauRegistre.etesVousMembreAutreOrdre"
      :live="{ endpoint: 'sas-inscriptions-tableau-registre', cle: '2308', fileId: sas.sasInscriptionAuTableauRegistre.id }"
      :disabled="sas.membresAutreOrdre.some((m) => m.lectureSeule)"
    >
    </opq-catalogue>
    <data-iterator
      :opqIf="estOui(sas.sasInscriptionAuTableauRegistre.etesVousMembreAutreOrdre)"
      :list="sas.membresAutreOrdre"
      add-new-text="Ajouter un ordre professionnel"
      :live="{ endpoint: 'sas-membres-autre-ordre', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.ordreProfessionnel ? getCatalogueValueById(9426, item.ordreProfessionnel).text : "" }}</h3>
        <p class="my-0">
          {{ item.numeroPermis }}
        </p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-catalogue
          code="membre-autre-ordre-ordre"
          v-model="item.ordreProfessionnel"
          :live="liveSasMembresAutreOrdre(8102, item)"
          width="500"
          :filter="
            (fd) =>
              sas.membresAutreOrdre
                .filter((m) => m.id != item.id)
                .map((m) => m.ordreProfessionnel)
                .every((v) => fd.value != v)
          "
        ></opq-catalogue>
        <opq-text-field
          code="membre-autre-ordre-numero-permis"
          v-model="item.numeroPermis"
          :live="liveSasMembresAutreOrdre(8103, item)"
        ></opq-text-field>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormHybrid from "@/mixins/FormHybrid"
export default {
  mixins: [CataloguesHelper, FormHybrid],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasMembresAutreOrdre(cle, item) {
      return { endpoint: "sas-membres-autre-ordre", cle: cle, fileId: item.id }
    }
  },
  computed: {}
}
</script>

<style>
</style>